/* eslint-disable @typescript-eslint/naming-convention */
import { LogMessageRegistry, LogMessageSegment } from './log-message-registry.model'
import { generateInitialLogSegments } from './smart-default-generator'

export const userLogGenerators: LogMessageRegistry = {
  USER_LOGIN: log => {
    const segments: LogMessageSegment[] = []
    generateInitialLogSegments(segments, log)
    segments.push({ text: 'logged in.' })
    return segments
  },

  // Special case: Use "your profile" for self-updates.
  USER_UPDATE: log => {
    const segments: LogMessageSegment[] = []
    generateInitialLogSegments(segments, log)
    segments.push({ text: ' updated their profile.' })
    return segments
  }
}
